import { PassengerTypeConfig } from '../../types';
import { Action } from 'redux-actions';
import { SET_PASSENGERS_CONFIG } from './actions';

export interface PassengerConfigState {
	[type: string]: PassengerTypeConfig;
}

export const passengersConfigReducer = (state: PassengerConfigState = {}, action: Action<PassengerConfigState>) => {
	if (action.type === SET_PASSENGERS_CONFIG) {
		return action.payload;
	}

	return state;
};
